import React from "react";
import Logs from "../../../../components/Logs";
import { VALAQUENTA_API_URL } from "../../../../api";

const AccEngineConfigLogsTab = (WrappedComponent) => {
  const Comp = (props) => {
    const actionsMapping = {
      add: {
        label: "Add",
        url: `${VALAQUENTA_API_URL}/accengine/account-config/`,
        method: "POST",
      },
      edit: {
        label: "Edit",
        url: `${VALAQUENTA_API_URL}/accengine/account-config/`,
        method: "PATCH",
      },
      delete: {
        label: "Delete",
        url: `${VALAQUENTA_API_URL}/accengine/account-config/`,
        method: "DELETE",
      },
      clone: {
        label: "Clone",
        url: `${VALAQUENTA_API_URL}/accengine/account-config/clone/`,
        method: "POST",
      },
    };

    return <WrappedComponent {...props} actionsMapping={actionsMapping} />;
  };
  return Comp;
};

export default AccEngineConfigLogsTab(Logs);
